export var borderRadius = {
    /** 2px */
    small: '2px',
    /** 3px */
    default: '3px',
    /** 6px */
    large: '6px',
    /** 12px */
    extraLarge: '12px'
};
//# sourceMappingURL=borderRadius.js.map